import DropdownMenu from "../DropdownMenu";
import ApexTable from "apex-table-ts";
import React from "react";
import "./styles.scss";

export interface TableProps {
  tableData: any[];
  columns: {};
  csvFileName: string;
}
const DataTable = ({ tableData, columns, csvFileName }: TableProps) => {
  return (
    <ApexTable
      enableColumnSort
      defaultSortColumn=""
      columns={columns}
      rows={tableData}
      enableCsvExport
      height={450}
      enableColumnFilters
      showHideColumns={{
        localStorageNamespace: columns,
        menuTitle: "Show/Hide Columns",
        menuWrapper: DropdownMenu,
      }}
      csvLinkText={"Export to CSV"}
      csvFilename={csvFileName}
      enableClearFilters
      enableSortIcons={false}
    />
  );
};
export default DataTable;
